<script lang="ts">
  import { onDestroy } from "svelte"
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import { newNotification } from "@kontextwerk/web-sdk/core/overlay/notifications"
  import { runImportantActionWithReauth } from "@kontextwerk/web-sdk/ui/security/importantActionReauth"
  import type { DemoDataResetJobStartResponse } from "../../../../../../../../../../../../../../../../api/kehrblatt/demo-data"
  import type { DemoResetProfileOutput } from "../../../../_shared/_logic/demo-data-reset-contract"
  import type { StartDemoResetOperations } from "../../actions/startDemoReset"
  import { startDemoResetOperations } from "./operations"

  const {
    organizationId,
    admin,
    employee,
    operations = startDemoResetOperations,
    onSubmittingChange,
    onStarted,
  }: {
    organizationId: string
    admin: DemoResetProfileOutput
    employee: DemoResetProfileOutput
    operations?: StartDemoResetOperations
    onSubmittingChange: (submitting: boolean) => void
    onStarted: (job: DemoDataResetJobStartResponse) => void
  } = $props()

  let submitting = $state(false)
  let idempotencyKey: string | null = null
  let requestController: AbortController | null = null

  const start = async () => {
    if (submitting) return

    submitting = true
    onSubmittingChange(true)
    const controller = new AbortController()
    requestController?.abort()
    requestController = controller
    idempotencyKey ??= crypto.randomUUID()
    try {
      const result = await runImportantActionWithReauth(
        {
          title: "Testzugang zurücksetzen",
          description:
            "Alle bestehenden Testdaten dieses Testzugangs werden gelöscht und neu erstellt. Bitte bestätigen Sie diese Aktion mit Ihrem aktuellen Passwort.",
          actionLabel: "Testzugang zurücksetzen",
          preserveParent: true,
        },
        () =>
          operations.enqueue({
            organizationId,
            admin: { ...admin },
            employee: { ...employee },
            idempotencyKey: idempotencyKey as string,
            signal: controller.signal,
          }),
      )

      if (result && !controller.signal.aborted) onStarted(result)
    } catch {
      if (controller.signal.aborted) return

      newNotification({ class: "error", html: "Demodaten-Reset konnte nicht gestartet werden." })
    } finally {
      if (requestController === controller) requestController = null

      submitting = false
      onSubmittingChange(false)
    }
  }

  onDestroy(() => requestController?.abort())
</script>

<CTA
  type="primaryButton"
  content={submitting ? "Reset wird gestartet…" : "Zurücksetzen"}
  onClick={start}
  disabled={submitting}
/>
